<template>
  <section
    class="intro"
    :class="pausedClasses"
    :style="{
      'background-image': `url(${poster})`
    }"
  >
    <div class="intro-wrap">
      <video
        class="intro-video"
        :src="heroVideo"
        autoplay
        muted
        playsinline
        ref="video"
        poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        @playing="paused = false"
      ></video>
    </div>
    <Container>
      <img
        :src="require('@/assets/images/icons/nosop3.svg')"
        alt="NOS"
        class="logo"
        width="100"
        draggable="false"
      />
      <div class="top">
        <h1 class="title">Ik zie wat jij niet ziet</h1>
        <p class="subtitle">en de kleur is zwart</p>
      </div>
      <div class="alert">
        <AudioOnIcon class="audio-on-icon"></AudioOnIcon>
        <p class="warning">
          Deze special ervaar je beter met geluid
        </p>
        <div class="scroll-down">
          <svg width="18" height="21" viewBox="0 0 18 21" xmlns="http://www.w3.org/2000/svg"><path d="M1.11 1.89l7.778 7.778 7.78-7.778m-15.558 10l7.778 7.777 7.78-7.777" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd" stroke-linecap="round"/></svg>
        </div>
      </div>
      <Fader></Fader>
      <Content>
        <p>De vraag naar psychische hulp is groter dan ooit: drie op de tien jongeren voelen zich depressief. Dat zie je niet meteen aan de buitenkant. Zes jonge mensen vertellen hoe alledaagse situaties voor hen grote obstakels zijn. In deze special kruip jij een dag in hun hoofd en ervaar je hoe dat voelt.</p>
      </Content>
    </Container>
  </section>
</template>

<script>
import { Content, Container } from '@/components/chapter'
import { Fader } from '@/components/fader'
import { AudioOnIcon } from '@/components/icons'
import { mediaQueryMixin, doneMixin, chapterMixin } from '@/mixins'
import media from '@/utils/media'

export default {
  name: 'Intro',
  mixins: [mediaQueryMixin, doneMixin, chapterMixin],
  data () {
    return {
      paused: true
    }
  },
  components: {
    AudioOnIcon,
    Container,
    Content,
    Fader
  },
  computed: {
    heroVideo () {
      const size = this.mobile ? 'mobile' : 'desktop'
      return media.intro.hero[size]
    },
    pausedClasses () {
      return {
        'is-done': this.done,
        'is-not-done': !this.done,
        'paused': this.paused && this.mobile,
        'not-paused': !this.paused,
        'desktop': !this.mobile
      }
    },
    poster () {
      return media.intro.poster
    }
  }
}
</script>

<style lang="scss" scoped>
.intro {
  background-color: $c-light;
  color: white;
  text-align: center;
  position: relative;

  @media (min-width: 768px) {
    padding-bottom: 80px;
  }
}
.intro-wrap {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  margin: 0 auto;
  width: 800px;

  &:before {
    background: linear-gradient(to bottom, rgba(235, 234, 233, 0) 90%, $c-light 100%), linear-gradient(to left, rgba(235, 234, 233, 0) 90%, $c-light 100%), linear-gradient(to right, rgba(235, 234, 233, 0) 90%, $c-light 100%);
    content: '';
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.intro-video {
  margin: 0 auto;
  width: 800px;
  position: relative;
  z-index: -1;
}
.paused {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center;

  .intro-video {
    opacity: 0;
  }
}
.not-paused {
  background: $c-light !important;
}
.desktop {
  background: $c-light !important;

  .intro-video {
    display: block;
  }
}
.container {
  z-index: 2;
  position: relative;
}
.logo {
  position: absolute;
  top: 27px;
  left: 20px;
  z-index: 1;
}
.top {
  padding-top: 204px;
  padding-bottom: 46px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(25px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}

.title {
  font-size: 48px;
  font-weight: $fw-bold;
  margin: 0 auto 11px;
  line-height: 1.13;
  opacity: 0;
  transform: translateY(25px) scale(0.9);

  @media (min-width: 768px) {
    font-size: 72px;
  }
}
.subtitle {
  color: $c-red;
  opacity: 0;
  transform: translateY(25px) scale(0.9);
}
.is-done {
  .title {
    animation: fadeIn 3s forwards 3s;
  }
  .subtitle {
    animation: fadeIn 3s forwards 5s;
  }
}
.alert {
  padding-top: 92px;
  padding-bottom: 80px;
  font-size: 16px;
  line-height: 1.19;
  position: relative;

  @media (min-width: 768px) {
    padding-bottom: 164px;
  }
}
.audio-on-icon {
  position: relative;
  z-index: 2;
}
@keyframes arrowDown {
  0% {
    transform: translateY(0px);
    opacity: 0;
  }
  33%, 66% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(8px);
  }
}
.scroll-down {
  font-size: 0;
  position: relative;
  z-index: 2;
  text-align: center;
  margin: 20px auto 0;
  opacity: 0.8;
  animation: arrowDown 1700ms infinite;

  svg {
    position: absolute;
    top: 9px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}
.warning {
  max-width: 203px;
  margin: 15px auto 0;
  color: $c-red;
  position: relative;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/chapters/Intro.vue